import intl from "react-intl-universal";

import {deleteTaskListUnit as deleteTaskListUnitRequest} from "../../stores/taskLists/requests/deleteTaskListUnit";
import {snackBarRef} from "../../stores/snackbarRef";
import {TaskListUnit} from "../../stores/taskLists/gql/serverTypes";
import {IDataClientService} from "../../platform/services/data/DataClientService";
import {IAuthService} from "../../platform/services/auth/AuthService";


export const deleteTaskListUnit = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    taskListUnit: TaskListUnit
) => {
    await deleteTaskListUnitRequest(dataClientService, authService, taskListUnit);
    snackBarRef.current!.enqueueSnackbar({
        message: intl.get('taskListUnit.delete.success').d('Location deleted successfully'),
    })
}
